import { NgModule } from '@angular/core';
import { LoginRegisterDesktopPageComponent } from './pages/login-register-desktop-page/login-register-desktop-page.component';
import { VerificationDesktopPageComponent } from './pages/verification-desktop-page/verification-desktop-page.component';
import { PickNameDesktopPageComponent } from './pages/pick-name-desktop-page/pick-name-desktop-page.component';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoginRegisterComponent } from '../../../common/components/auth/login-register/login-register.component';
import { PickNameComponent } from '../../../common/components/auth/pick-name/pick-name.component';
import { VerificationComponent } from '../../../common/components/auth/verification/verification.component';
import { RegisterGuard } from '../../../common/guards/register.guard';
import { AuthInterceptor } from '../../../common/interceptors/auth';
import { AuthDesktopComponent } from './auth-desktop.component';
import { AuthDesktopRoutingModule } from './auth-desktop-routing.module';
import { HeaderDesktopComponent } from '../components/layout/header/header-desktop.component';
import { FooterDesktopComponent } from '../components/layout/footer/footer-desktop.component';

@NgModule({
  imports: [
    CommonModule,
    AuthDesktopRoutingModule,
    HttpClientModule,
    LoginRegisterComponent,
    PickNameComponent,
    VerificationComponent,
    HeaderDesktopComponent,
    FooterDesktopComponent,
  ],
  declarations: [
    AuthDesktopComponent,
    LoginRegisterDesktopPageComponent,
    VerificationDesktopPageComponent,
    PickNameDesktopPageComponent,
  ],
  providers: [
    RegisterGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AuthDesktopModule {}
